<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12">
        <div class="row justify-content-center">
            <div class="col-sm-12 col-xs-12">
                    <div class="card-header pb-0 col-sm-12 d-flex mainDiv">
                        <div class="col-sm-12 col-xs-12">
                                <div
                                  class="col-sm-12 col-xs-12 titleDiv CertListTitle justify-content-between title-area">
                                <div>
                                  <h3>{{ $t('notices_title') }}</h3>
                                  <h5>{{ $t('notices_desc') }}</h5>
                                </div>
                                <!-- <a class="header-btn btn-hover" href="https://certi.life/#contact" target="_blank">
                                  {{ $t('companyinfo_request_change') }}
                                </a> -->
                              </div>
                                <div class="card-body px-0 pt-0 pb-2 table-with-search">
                                    <div class="col-xs-12 table-info-filter">
                                        <div />
                                        <div class="search-container">
                                          <a-select 
                                            style="width: 150px"
                                            v-model:value="rowsPerPage" 
                                            @change="handleRowsPerPage"
                                          >
                                            <a-select-option :value="10">10{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                                            <a-select-option :value="20">20{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                                            <a-select-option :value="50">50{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                                          </a-select>
                                        </div>
                                    </div>
                                    <a-table 
                                        class="ant-table-striped hover-pointer"
                                        size="small"
                                        :columns="columns"
                                        :data-source="responseData"
                                        :pagination="false"
                                        v-if="responseData.length > 0"
                                        :customRow="onRowClick"
                                    >
                                        <template #bodyCell="{ column, record }">
                                        </template>
                                    </a-table>
                                    <div class="no-result-container" v-else>
                                        <i class="fa-solid fa-exclamation-triangle" />
                                        <span>{{ computedNoResultMessage }} </span>
                                    </div>
                                </div>
                                <pagination 
                                v-if="!$store.state.isLoading && responseData.length > 0"
                                :page-info="paginationData"
                                page-name="NoticeList"
                                @change-page="paginationHandler"
                                />
                        </div>
                    </div>
            </div>
        </div>
  </div>
</template>
<script>
import { convertDate, oneBtnDialog,  } from '../utils/utils';
import NoResult from '../views/components/NoResult.vue';
import Pagination from '@/views/components/Pagination.vue';

export default {
  name: 'NoticeList',
  components: {
    NoResult,
    Pagination,

  },
  computed: {
    computedNoResultMessage() {
      if(this.calledApiTimes <= 1) {
        return this.$i18n.t('noresult_notice');
      } else {
        return this.$i18n.t('noresult_search');
      }
    },
  },
  data() {
    const page = this
        return {
            //모달 데이터
            customerModifyModalData: {},
            // 목록 받아오는 변수
            responseData: [],
            calledApiTimes: 0,
            columns:[
                    {
                        key: 'index', title: this.$t('itemslist_table_no'), dataIndex: 'index', align: 'center', width: "4%",
                    },
                    {
                        key: 'title', title: this.$t('notices_table_title'), dataIndex: 'title', align: 'start',
                        customRender: ({text, record}) => {
                            return record.fileUrls.length > 0 ? (
                                <div>
                                <img
                                    style={{ width: '15px', marginRight: '5px' }}
                                    src={require('../assets/img/attachment.png')}
                                />
                                {record.title}
                                </div>
                            ) : (
                                <div>{record.title}</div>
                            );
                        },
                    },
                    {
                        key: 'createAt', title: this.$t('notices_table_createdat'), dataIndex: 'createAt', align: 'start',
                            customRender: ({text, record}) => {
                                return convertDate(record.createAt)
                            },
                    },
            ],
        onRowClick(record, rowIndex) {
            
            return {
                onClick: event => {
                    page.$router.push({
                        name: 'NoticeRead',
                        params: { id: record._id },
                        query: { page: page.paginationData.currentPage },
                    });
                },
            };
        },
        // 페이지네이션 관련 변수
        listSize: 0,
        rowsPerPage: 10, 
        paginationData: {
            currentPage: 1, 
            totalPages: 0,
        },
        condition: 'MANUFACTURER',
        };
  },
  props: ['previousPage'],
  async mounted() {
    // 이거 해결해야 함
    if (this.$route.query.page === undefined) {
      this.paginationData.currentPage = 1;
    } else {
      this.paginationData.currentPage = this.$route.query.page;
    }
    const obj = {};
    obj.page = this.paginationData.currentPage;
    this.paginationHandler(obj);
    
  },
  methods: {
    routeToPost() {},
    async paginationHandler(childPassParam) {
      this.paginationData.currentPage = childPassParam.page;
      await this.getNoticeList();
    },
    // 공지사항 목록 전체
    async getNoticeList() {
      const params = {};
      params.page = this.paginationData.currentPage;
      params.limit = this.rowsPerPage;
      params.target = this.condition;
      try {
        const response = await this.$apiInstance.get(`/notices`, { params });
        if (response.status === 200 || response.status === 201) {
          this.calledApiTimes ++;
          this.paginationData.currentPageSize = response.data.totalPages;
          this.responseData = response.data.docs;
          this.listSize = response.data.totalDocs;
          for (let i = 0; i < this.responseData.length; i++) {
            this.responseData[i].index =
              this.listSize - i - (this.paginationData.currentPage - 1) * this.rowsPerPage;
          }
          this.paginationData.totalPages = response.data.totalPages;
          this.isLastPage = response.data.page === response.data.totalPages;
        }
      } catch (error) {
        console.log(error);
        oneBtnDialog(this.$i18n.t('notices_load_err_title'), this.$i18n.t('notices_load_err_content'), false);
      }
    },
    async handleRowsPerPage() {
      this.paginationData.currentPage = 1;
      await this.getNoticeList();
    },
    // 글 보기로 이동

    convertDate,
  },
};
</script>
